/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
export let AbDimensions;
(function (_AbDimensions) {
  const equal = _AbDimensions.equal = (d1, d2) => {
    return d1?.width === d2?.width && d1?.height === d2?.height;
  };
  const map = _AbDimensions.map = (d, f) => {
    return {
      width: f(d.width),
      height: f(d.height)
    };
  };
  const floor = _AbDimensions.floor = d => AbDimensions.map(d, Math.floor);
  const isSafeForRendering = _AbDimensions.isSafeForRendering = d => {
    // Possibly, should be > 0 for width and height
    return d !== undefined && !Number.isNaN(d.width) && !Number.isNaN(d.height) && d.width >= 0 && d.height >= 0;
  };
  const fromResizeObserverEntry = _AbDimensions.fromResizeObserverEntry = entry => {
    if (entry.contentBoxSize && entry.contentBoxSize.length > 0) {
      return {
        width: entry.contentBoxSize[0].inlineSize,
        height: entry.contentBoxSize[0].blockSize
      };
    } else {
      return {
        width: entry.contentRect.width,
        height: entry.contentRect.height
      };
    }
  };
  const fromElementContentBox = _AbDimensions.fromElementContentBox = element => {
    const style = getComputedStyle(element);
    const topPadding = parseInt(style.paddingTop) ?? 0;
    const rightPadding = parseInt(style.paddingRight) ?? 0;
    const bottomPadding = parseInt(style.paddingBottom) ?? 0;
    const leftPadding = parseInt(style.paddingLeft) ?? 0;
    return {
      width: Math.floor(element.clientWidth - leftPadding - rightPadding),
      height: Math.floor(element.clientHeight - topPadding - bottomPadding)
    };
  };
})(AbDimensions || (AbDimensions = {}));
//# sourceMappingURL=AbDimensions.js.map
